import { Divider as MuiDivider } from "@mui/material";
import type { JSX } from "react";

import { StylableProps } from "@rewards-web/shared/types";

interface DividerProps extends StylableProps {
  orientation?: "horizontal" | "vertical";
  flexItem?: boolean;
}

export function Divider({
  orientation,
  flexItem,
  className,
}: DividerProps): JSX.Element {
  return (
    <MuiDivider
      orientation={orientation ?? "horizontal"}
      className={className}
      flexItem={flexItem}
    />
  );
}
